export { default } from "./ViewGameLog";
